import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DownloadService } from '../downloads/download.service';
import { ToastService } from '../toast/toast.service';
import { UtilsService } from '../utils/utils.service';
import { HelpersService } from '../helpers/helpers.service';
import { BehaviorSubject, Observable, throwError, forkJoin, map } from 'rxjs';
import * as _ from 'lodash'
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class ActionService {
  isGroupQuestionAvailable: boolean = false
  allQuesitonsMapData: any = {}
  brandDetails: any = {}
  questionMapping: any = {
    questions: {},
    questionGroups: {}
  }
  hierarchyLevels: any = []
  mappedHierarchy: any = {}
  filterNameMap: any = {}
  hierarchyStack: any = [];
  selectedDrilldownFilter: any;
  drilldownTable: any;
  filters: any = [];
  trendDisplayName = "";
  private drilldownFiltersSubject = new BehaviorSubject<any[]>([]);
  filters$ = this.drilldownFiltersSubject.asObservable();
  dropdownOtions: any = []
  isSingleTouchpointSetup: boolean = false
  dateFormats: any = {
    'Hourly': "HH:MM:SS",
    'Daily': "DD MMM YYYY",
    'Weekly': "DD MMM YYYY",
    'Monthly': "MMM YYYY",
    'Quarterly': "MMM YYYY",
    'Yearly': "YYYY",
  }
  status_closed_uuid: any = ["c71a8524-7fc4-49d3-894a-2555dcc6ed07"]

  constructor(public _utilService: UtilsService, private _toastService: ToastService, private downloadService: DownloadService, public _helpers: HelpersService) { }

  getInitialQueryParameters() {
    var initialQueryParams: any = {};
    var parameter: any = this._helpers.getInitialQueryParameters();
    initialQueryParams.from = _.get(Helpers, 'datePicker.startDate');
    initialQueryParams.to = _.get(Helpers, 'datePicker.endDate');
    initialQueryParams.is_custom_date_range_selected = _.get(Helpers, 'datePicker.isCustomDateRangeSelected', false);

    if (!_.isEmpty(parameter)) {
      initialQueryParams = {
        "manager_type": parameter.manager_type,
        "brand_id": parameter.brand_id,
        "main_rater_type": this.brandDetails.main_rater_type
      }

      if (Helpers.hierarchyStack && Helpers.hierarchyStack.length) {
        initialQueryParams.hierarchy_stack = Helpers.hierarchyStack;
      }

      if (Helpers.customFilterNextLevel && _.get(this.brandDetails, "is_single_touchpoint_setup")) {
        initialQueryParams.group_alias_key = Helpers.customFilterNextLevel;
      }

      if (Helpers.customFilterList && Helpers.customFilterList.length) {
        initialQueryParams.hierarchy_stack = [];
        Helpers.customFilterList.forEach(function (filter: any) {
          initialQueryParams.hierarchy_stack.push({
            "field_id": filter.field,
            "group_key": [filter.value]
          })
        });
      }
    }

    return initialQueryParams;
  }

  getSelectedDrilldownFilter() {
    return this.selectedDrilldownFilter;
  }
  setSelectedDrilldownFilter(filter) {
    this.selectedDrilldownFilter = filter
  }
  clearSelectedDrilldownFilter() {
    this.selectedDrilldownFilter = null
  }
  getInitializedTable(table?: any) {
    let initializedTable = _.cloneDeep(table)
    initializedTable['tableRow'] = this.resetMetrics(initializedTable['tableRow']);
    if (initializedTable) {
      this.drilldownTable = initializedTable;
    }
  }
  resetMetrics(data) {
    if (data.length) {
      data.forEach(item => {
        item.doc_count = 0;
        item.resolved = 0;
        item.unresolved = 0;

        if (Array.isArray(item.drillDown) && item.drillDown.length > 0) {
          this.resetMetrics(item.drillDown);
        }
      });
      return data;
    } else {
      return [];
    }
  }
  clearDrilldownHistory() {
    this.drilldownTable = [];
    this.clearSelectedDrilldownFilter();
  }
  generateApiParams(data, baseParams) {
    const result: any = [];
    const filtersArray: any = [];

    function traverse(node, hierarchyStack = []) {
      if (node.isExpanded && Array.isArray(node.drillDown) && node.drillDown.length > 0) {
        const newStack: any = [...hierarchyStack, {
          field_id: node.field_id,
          field_type: node.field_type,
          field_value: node.name,
          group_key: [node.name]
        }];

        const childFieldId = node.drillDown[0].field_id;

        // Push the API param object
        result.push({
          ...baseParams,
          hierarchy_stack: newStack,
          field_id: childFieldId,
          group_key_alias: node.field_id,
          field_type: node.field_type
          // field_type: "hierarchy"
        });
        if (node.field_id && node.name) {
          filtersArray.push({
            field_id: node.field_id,
            group_key: node.name
          });
        }
        node.drillDown.forEach(child => traverse(child, newStack));
      }
    }

    data.forEach(region => traverse(region));

    return { api_params: result, filters: filtersArray };
  }

  setDrilldownFilters(filters) {
    this.filters = [];
    if (filters && filters.filters && filters.filters.length) {
      _.each(filters.filters, (filter) => {
        if (filter && filter.field_id == filters.groupKeyAlias) {
          this.trendDisplayName = filter.field_value
        } else {
          this.trendDisplayName = this.getDisplayName()
        }
        let tmpObj = {
          "field_id": filter.field_id,
          "group_key": filter.group_key
        }
        this.filters.push(tmpObj);
      })
    } else {
      this.filters = [];
      this.trendDisplayName = this.getDisplayName()
    }
    this.drilldownFiltersSubject.next(this.filters);
    return this.filters;
  }

  getDisplayName(){
    let hierarchyStack = this._helpers.getHierarchyStack()
    if (hierarchyStack && hierarchyStack.length && hierarchyStack[hierarchyStack.length - 1]?.group_key[0]){
      return hierarchyStack[hierarchyStack.length - 1]?.group_key[0];
    } else {
      return "NA";
    }
  }

  getNextHierarchy(fieldId: string) {
    let filter: any = {}
    const index = this.hierarchyLevels.indexOf(fieldId);

    if (this.hierarchyLevels[index + 1]) {
      const alias = this.hierarchyLevels[index + 1]
      filter = this.mappedHierarchy[alias];
    } else if (!this.isSingleTouchpointSetup && fieldId != 'touchpoint') {
      filter = {
        'field_id': 'touchpoint',
        'name': 'Touchpoints',
        'label': 'Touchpoints',
        'type': 'hierarchy'
      }
    }
    return filter;
  }

  isEndOfHierarchy(fieldId?: string) {
    if (fieldId) {
      const index = this.hierarchyLevels.indexOf(fieldId);
      const value = this.brandDetails.is_single_touchpoint_setup ? 2 : 1;
      return (index >= (this.hierarchyLevels.length - value))
    }
    return true;

  }
  getGroupAlias(fieldId: string) {
    const index = this.hierarchyLevels.indexOf(fieldId)
    let groupAliasKey = fieldId
    if (groupAliasKey == 'touchpoint') {
      groupAliasKey = this.hierarchyLevels[this.hierarchyLevels.length - 1]
    } else if (index <= 0) {
      groupAliasKey = 'brands';
    } else {
      groupAliasKey = this.hierarchyLevels[index - 1]
    }
    return groupAliasKey;
  }

  getGroupAliasKey(fieldId: string, hierarchyListAlias: any) {
    let hierarchyLevels:any = [] 
    let groupAliasKey = fieldId;
    if (!_.isEmpty(hierarchyListAlias)) {
      var keys = Object.keys(hierarchyListAlias);
      hierarchyLevels = hierarchyListAlias[keys[0]].values;
    }
    if (fieldId) {
      const index = hierarchyLevels.indexOf(fieldId);
      if (index < hierarchyLevels.length - 1) {
        groupAliasKey = hierarchyLevels[index + 1]
      }
    } else {
      groupAliasKey = 'brands'
    }
    return groupAliasKey
  }

  getDropDownOptions() {
    let options = _.uniqWith(this.dropdownOtions, _.isEqual);
    return options;
  }

  prepareViewTypeDropdown(brandDetail:any, hierarchyStack?:any) {
    let options:any = [];
    let hierarchyList: any =[];
    let hierarchyMapping: any =[];
    let selectedHierarchyKey: string = '';
    let hierarchyListAliasValue: any =[];
    let currentHierarchyLevel: string = '';
    let currentHierarchyLevelName: string = '';
    let group_key_alias: string = '';
    let obj: any = {}

      let hierarchyListFromBrand = brandDetail?.hierarchy_list;
      for(let key in hierarchyListFromBrand) {
        selectedHierarchyKey = key;
        hierarchyList = hierarchyListFromBrand[key];
      }
      let hierarchyListAliasValueFromBrand = brandDetail?.hierarchy_list_alias;
      if(hierarchyListAliasValueFromBrand && hierarchyListAliasValueFromBrand[selectedHierarchyKey]) {
        hierarchyListAliasValue = hierarchyListAliasValueFromBrand[selectedHierarchyKey]?.values;
      }
      if(hierarchyList && hierarchyList.length > 0) {
        hierarchyListAliasValue.forEach((item, index) => {
          hierarchyMapping[item] = hierarchyList[index];
        })
        if(hierarchyStack && hierarchyStack.length > 0) {
          currentHierarchyLevel = hierarchyStack[hierarchyStack.length - 1]?.field_id;
          currentHierarchyLevelName = hierarchyStack?.[hierarchyStack.length - 1]?.group_key[0];
          if(currentHierarchyLevel && currentHierarchyLevel != '') {
            let startAdding: boolean = false;
            for (let key in hierarchyMapping) {
              if (startAdding) {
                if(hierarchyMapping[key]) {
                  options.push({name: hierarchyMapping[key], field_id: key, field_type: 'hierarchy', category: 'Hierarchy'});
                }
              }
              if (key === hierarchyListAliasValue[hierarchyListAliasValue.indexOf(currentHierarchyLevel) + 1]) {
                startAdding = true;
                if(hierarchyMapping[key]) {
                  options.push({name: hierarchyMapping[key], field_id: key, field_type: 'hierarchy', category: 'Hierarchy'});
                }
              }
            }
          } else {
            currentHierarchyLevel = hierarchyListAliasValue[0];
            currentHierarchyLevelName = hierarchyList[0];
            for(let key in hierarchyMapping) {
              if(hierarchyMapping[key]) {
                options.push({name: hierarchyMapping[key], field_id: key, field_type: 'hierarchy', category: 'Hierarchy'});
              }
            }
          }
        } else {
          currentHierarchyLevel = hierarchyListAliasValue[0];
          currentHierarchyLevelName = hierarchyList[0];
          for(let key in hierarchyMapping) {
            if(hierarchyMapping[key] && key !== Object.keys(hierarchyMapping)[0]) {
              options.push({name: hierarchyMapping[key], field_id: key, field_type: 'hierarchy', category: 'Hierarchy'});
            }
          }
        }
        group_key_alias = hierarchyListAliasValue[hierarchyListAliasValue.indexOf(currentHierarchyLevel)+1];
      }
      const brandFieldDefinitions: any = brandDetail?.field_definitions;
      if(brandFieldDefinitions && brandFieldDefinitions.length > 0) {
        brandFieldDefinitions.forEach((fieldDefinition: any) => {
          if(fieldDefinition?.compare_filter) {
            if (fieldDefinition?.compare_filter && fieldDefinition?.child) {
              options.push({name: fieldDefinition?.name, field_id: fieldDefinition?.field_id, field_type: 'tag', category: 'Cohorts', child:fieldDefinition?.child})  
            } else {
              options.push({name: fieldDefinition?.name, field_id: fieldDefinition?.field_id, field_type: 'tag', category: 'Cohorts'})
            }
          }
          this.filterNameMap[fieldDefinition.field_id] = fieldDefinition
        })
      }
      obj = {
        hierarchyMapping:hierarchyMapping,
        options: options,
        hierarchyList: hierarchyList,
        hierarchyListAliasValue: hierarchyListAliasValue,
        group_key_alias: group_key_alias,
        currentHierarchyLevel: currentHierarchyLevel,
        currentHierarchyLevelName: currentHierarchyLevelName
      }
      return obj;
  }

  private setDropDownOptions(brandDetail: any) {
    let options: any[] = []
    if (brandDetail.hierarchy_list && !_.isEmpty(brandDetail.hierarchy_list) && brandDetail.hierarchy_list_alias && !_.isEmpty(brandDetail.hierarchy_list_alias)) {
      var hierarchyList = _.get(brandDetail, 'hierarchy_list');
      var hierarchyListAlias = _.get(brandDetail, 'hierarchy_list_alias');
      var keys = Object.keys(hierarchyList);
      keys = _.filter(keys, (key: string) => {
        return key != 'default';
      });
      var labels = hierarchyList[keys[0]];
      var fields = hierarchyListAlias[keys[0]].values
      this.hierarchyLevels = fields
      for (let key in fields) {
        const alias = fields[key]
        this.dropdownOtions.push({
          'field_id': alias,
          'name': labels[key],
          'type': 'hierarchy',
          'category': 'Hierarchy'
        })
        this.mappedHierarchy[alias] = {
          'field_id': alias,
          'name': labels[key],
          'type': 'hierarchy',
          'category': 'Hierarchy'
        }
      }
    }
    // Removed this because touchpoint option is not required for dynamic hierarchy project
    // this.dropdownOtions.push({
    //   'field_id': 'touchpoint',
    //   'name': 'Touchpoints',
    //   'type': 'touchpoint',
    //   'category': 'Hierarchy'
    // })
    if (brandDetail.field_definitions && !_.isEmpty(brandDetail.field_definitions)) {
      let fieldDefinitions = _.get(brandDetail, 'field_definitions')
      _.each(fieldDefinitions, (field: any) => {
        if (field.compare_filter) {
          field.type = 'tag'
          field.category = 'Cohorts'
          this.dropdownOtions.push(field);
        } else if (field.field_type && field.field_type == 'response') {
          field.category = 'Cohorts'
          if (field.question) {
            field.name = field.question;
          } else {
            field.name = field.text;
          }
          if (field.type && field.type == "multi-select") {
            field = this.getPrpsAndPossibleValuesForMultiSelect(field);
          }
          this.dropdownOtions.push(field);
        }
      })
    }

    return options;
  }

  getPrpsAndPossibleValuesForMultiSelect(question: any) {
    let options: any = [];
    _.each(this.allQuesitonsMapData, function (ques: any) {
      if (ques.group_id && ques.group_id == question.field_id && ques.field_id && ques.value && !ques.is_deleted) {
        options.push({
          field_id: ques.field_id,
          value: ques.value
        });
      }
    })
    if (options.length) {
      question.possible_values = options;
    }
    return question;
  }
  private setQuestionAndQuestionGroup(brandDetail: any) {
    // Get quesitons from the brand details
    var questions = _.get(brandDetail, 'detailed_feedback_items');

    _.each(questions, (question: any) => {
      this.allQuesitonsMapData[question.field_id] = question
    })


    // For each quesiton process the data of quesiton
    _.each(this.allQuesitonsMapData, (question: any) => {
      if (question.group_id) {
        question.prop = _.map(question.prop, (option: any) => {
          if (!option.active_color && _.hasIn(this.allQuesitonsMapData, question.group_id + '.prop.' + option.value + '.active_color')) {
            option.active_color = _.get(this.allQuesitonsMapData, question.group_id + '.prop.' + option.value + '.active_color');
          }
          return option;
        })
        this.allQuesitonsMapData[question.field_id] = question;
      }
      // If question typw is rating, single-select, multi-select then only add thet question
      if ('type' in question && !question.is_deleted && ((question.is_displayed_on_dashboard || question.is_display_on_dashboard) || question.group_id) &&
        (question.type == 'rating' || question.type == 'single-select' || question.type == 'multi-select' || (question.type == "text" && !question.is_user_info)) &&
        !(question.type == 'single-select' && question.group_id)) {
        var field_id = question.field_id;
        var text = question.text;
        if (question.question && question.question != "") {
          text = question.question;
        }
        var type = question.type;
        var main_rater_type = question.main_rater_type;
        var possibleValues = question.possible_values;
        var component_type = question.question_component_type ? question.question_component_type : question.component_type;
        var iconUrl = 'https://static1.litmusworld.com/interaction_icons/' + component_type + '.svg';
        var iconClass = 'lw-icon-' + component_type;
        var prop = question.prop;
        if (question.group_id && this.questionMapping.questions[question.group_id]) {
          if (this.allQuesitonsMapData[question.group_id].is_displayed_on_dashboard || this.allQuesitonsMapData[question.group_id].is_display_on_dashboard) {
            this.questionMapping.questions[question.group_id].fieldIds.push(field_id);
          }
        } else if (question.type == 'multi-select' && (question.is_displayed_on_dashboard || question.is_display_on_dashboard)) {
          this.questionMapping.questions[field_id] = {
            'field_id': field_id,
            'fieldIds': [],
            'text': text,
            'type': type,
            'possible_values': possibleValues,
            'icon_url': iconUrl,
            'icon_class': iconClass,
            'prop': prop
          };
        } else if (question.type != 'multi-select') {
          this.questionMapping.questions[field_id] = {
            'field_id': field_id,
            'fieldIds': [field_id],
            'text': text,
            'type': type,
            'possible_values': possibleValues,
            'icon_url': iconUrl,
            'icon_class': iconClass,
            'prop': prop
          };
          if (type == 'rating' && main_rater_type) {
            this.questionMapping.questions[field_id]['main_rater_type'] = main_rater_type;
          } else if (type == 'rating') {
            var first = possibleValues[0];
            var last = possibleValues[possibleValues.length - 1];
            if (first == -5 && last == 5) {
              this.questionMapping.questions[field_id]['main_rater_type'] = 1;
            } else if (first == 0 && last == 10) {
              this.questionMapping.questions[field_id]['main_rater_type'] = 3;
            } else if (first == 1 && last == 10) {
              this.questionMapping.questions[field_id]['main_rater_type'] = 6;
            } else if (first == 1 && last == 6) {
              this.questionMapping.questions[field_id]['main_rater_type'] = 7;
            } else if (first == -3 && last == 3) {
              this.questionMapping.questions[field_id]['main_rater_type'] = 8;
            } else if (first == 1 && last == 4) {
              this.questionMapping.questions[field_id]['main_rater_type'] = 9;
            } else {
              this.questionMapping.questions[field_id]['main_rater_type'] = 4;
            }
          }
        }
        // If the question has group property then process that in question group
        if (_.hasIn(question, 'dynamic_properties.question_group') && question.dynamic_properties.question_group.length) {
          var questionGroup = question.dynamic_properties.question_group;
          for (var quesGroupIndex in questionGroup) {
            var quesGrpId = questionGroup[quesGroupIndex].id;
            // If the question type is already added on the quesiton group then appnd that question on that group
            if (_.hasIn(this.questionMapping.questionGroups, quesGrpId)) {
              this.questionMapping.questionGroups[quesGrpId]['fieldIds'].push(field_id)
            } else {
              // Create new question group
              this.questionMapping.questionGroups[quesGrpId] = {};
              this.questionMapping.questionGroups[quesGrpId]['field_id'] = quesGrpId;
              this.questionMapping.questionGroups[quesGrpId]['text'] = questionGroup[quesGroupIndex].name;
              this.questionMapping.questionGroups[quesGrpId]['fieldIds'] = [];
              this.questionMapping.questionGroups[quesGrpId]['fieldIds'].push(field_id);
              this.questionMapping.questionGroups[quesGrpId]['type'] = type;
              this.questionMapping.questionGroups[quesGrpId]['possible_values'] = possibleValues;
              this.questionMapping.questionGroups[quesGrpId]['icon_url'] = iconUrl;
              this.questionMapping.questionGroups[quesGrpId]['icon_class'] = iconClass;
              this.questionMapping.questionGroups[quesGrpId]['prop'] = prop;
              if (type == 'rating' && main_rater_type) {
                this.questionMapping.questionGroups[quesGrpId]['main_rater_type'] = main_rater_type;
              } else if (type == 'rating') {
                var first = possibleValues[0];
                var last = possibleValues[possibleValues.length - 1];
                if (first == -5 && last == 5) {
                  this.questionMapping.questionGroups[quesGrpId]['main_rater_type'] = 1;
                } else if (first == 0 && last == 10) {
                  this.questionMapping.questionGroups[quesGrpId]['main_rater_type'] = 3;
                } else if (first == 1 && last == 10) {
                  this.questionMapping.questionGroups[quesGrpId]['main_rater_type'] = 6;
                } else if (first == 1 && last == 6) {
                  this.questionMapping.questionGroups[quesGrpId]['main_rater_type'] = 7;
                } else if (first == -3 && last == 3) {
                  this.questionMapping.questionGroups[quesGrpId]['main_rater_type'] = 8;
                } else if (first == 1 && last == 4) {
                  this.questionMapping.questionGroups[quesGrpId]['main_rater_type'] = 9;
                } else {
                  this.questionMapping.questionGroups[quesGrpId]['main_rater_type'] = 4;
                }
              }
            }
          }
        }
      }

    })

    var groups = Object.keys(this.questionMapping.questionGroups);
    if (groups && groups.length > 0) {
      this.isGroupQuestionAvailable = true;
    }
  }

  setClosedStatus(brandDetails: any) {
    //get value of closed status from brand
    // var status_closed_uuid = "c71a8524-7fc4-49d3-894a-2555dcc6ed07";
    if (_.hasIn(brandDetails, 'lw_status_list_map.LW_CLOSED')) {
      this.status_closed_uuid = brandDetails.lw_status_list_map.LW_CLOSED
    } else {
      var maped_status = {}
      if (_.hasIn(brandDetails, "status_list")) {
        var status_list = brandDetails.status_list
        for (var index in status_list) {
          maped_status[status_list[index].name] = status_list[index]
        }
      }
      if (_.hasIn(maped_status, "Closed.uuid")) {
        this.status_closed_uuid = [maped_status['Closed']['uuid']]
      }
    }
  }
  getClosedStatus() {
    return this.status_closed_uuid
  }

  configureActionService(brandDetails: any) {
    this.brandDetails = brandDetails
    this.isSingleTouchpointSetup = _.get(brandDetails, 'is_single_touchpoint_setup', false)
    this.setQuestionAndQuestionGroup(brandDetails)
    this.setDropDownOptions(brandDetails)
    this.setClosedStatus(brandDetails)
    return this.questionMapping;
  }
  /**
* Expected Parameters:
 *
 * params.brand_id - Required/Optional - string - Unique Identification of the brand
 * params.shop_id - Optional/Required - string - List of unique identification of the touchpoints
 * params.group_id - Required/Optional - string - Unique identification of the group
 * params.brand_id_list - Required/Optional - array - Array of brand_id of a group
 * params.main_rater_type - Required/Optional - number - Main rater type 1, 3, 10 etc this main_rater_type is reuired if there are brand_id_list
 * params.from - optional - string(YYYYMMDD) - Date from which the data is required
 * params.to - optional - string(YYYYMMDD) - Date to which the data is required.
 * params.custom_filter_list - optional - Array - to filter feeds by hierarchy tag private value,
 * params.is_custom_date_range_selected - required - boolean - If the it is true then it dosen't show previous date data
 * params.hierarchy_stack: Optional (Required If group_is is available in params: Array of objects which will contains the information about all the parents of selected Id
        eg: [{"field_id" : 'h_0_0', "group_key": ["tms__prod_hierarchy_management_management"]},
             {"field_id" : 'h_0_1', "group_key": ["tms__prod_hierarchy_region_east"]},
             {"field_id" : 'h_0_2', "group_key": ["tms__prod_hierarchy_state_assam"]}]
 * params.field_id - Required - Id on which apply group
 * params.field_type - required - type specifies the type of field_id - comments/text/hierarchy/tag/response
 * params.view_type - Required - View type will be list/ pie/ trends /overall
 * params.question_aggs - Required/Optional - Question aggregation is true of false
 * params.trend_type - Required/Optional - If the view type is bar then it required
 * params.size - Required/Optional - Size of aggregration bucket
 * params.field_data_type - optional - if field_type is tag then it reqired
 * params.possible_values - optional - Array - Ranges (['100,200', '200-300']) If field_data_type is ranges then it is required
 * params.filters - options - Array of filters object contains [{field_id:'', field_type:''....},...]
 * params.field_sub_type - Required/Optional - Question type rating/single-slect/multi-select
 * params.action_type - Required/Optional - summary,ageing or tat so get ageing and tat
   params.age_type - 1- normal 2-business
   params.turnaround (required if action_type is ageing or tat)
   params.date_field - default is created_date // field using which we have to filter the data.

 */
  getComparisonData(params: any) {
    try {
      const url = this._utilService.apiUrlGeneration(environment.actionV1, environment.actionV1.actionStatsComparisonData);
      return this._utilService.postAPICall(url, params, this._utilService.setHeaders())
      // let hierarchy = _.get(params, `group_key_alias`, 'brands');
      // const url = `../../../../../assets/mock-data/${hierarchy}/${params.field_type}.json`
      // return this._utilService.getDataFromFile(url)
    } catch (error) {
      console.error('An unexpected error occurred in validateEmail:', error);
      // Add your error handling logic for unexpected errors here
      return throwError('An unexpected error occurred'); // You can customize the error message as needed
    }
  }

  getDrillDownData(queries: any) {
    const apicalls: any = {}
    try {
      const url = this._utilService.apiUrlGeneration(environment.actionV1, environment.actionV1.actionStatsComparisonData);
      _.each(queries, (query: any) => {
        if (query.field_id != 'overall') {
          apicalls[query.field_id] = this._utilService.postAPICall(url, query, this._utilService.setHeaders())
          // let hierarchy = _.get(query, `group_key_alias`, 'brands');
          // const url = `../../../../../assets/mock-data/${hierarchy}/${query.field_type}.json`
          // apicalls[query.field_id] = this._utilService.getDataFromFile(url)
        }
      })
      if (!_.isEmpty(apicalls)) {
        return forkJoin(apicalls).pipe(map((response) => {
          return Object(response)
        }));
      } else {
        return new Observable((subscriber)=>{
          subscriber.next({})
          subscriber.complete()
        })
      }
    } catch (error) {
      console.error('An unexpected error occurred in validateEmail:', error);
      // Add your error handling logic for unexpected errors here
      return throwError('An unexpected error occurred'); // You can customize the error message as needed
    }


  }

  getTrendsData(params: any) {
    try {
      const url = this._utilService.apiUrlGeneration(environment.actionV1, environment.actionV1.ActionStatsTrendSummary);
      return this._utilService.postAPICall(url, params, this._utilService.setHeaders());
      // let hierarchy = _.get(params, `group_key_alias`, 'brands');
      // const trend_type = _.get(params, 'trend_type', 1)
      // const url = `../../../../../assets/mock-data/${hierarchy}/trends_${trend_type}.json`
      // return this._utilService.getDataFromFile(url)
    } catch (error) {
      console.error('An unexpected error occurred in validateEmail:', error);
      // Add your error handling logic for unexpected errors here
      return throwError('An unexpected error occurred'); // You can customize the error message as needed
    }
  }

  getRaterDetails(raterType: any) {
    var raters = {
      "1": {
        "name": "litmus",
        "min_score": -5,
        "max_score": 5,
        "distributions": [{
          "value": 2,
          "label": "Positives",
          "color": "#0b7139",
          "field_id": "positives"
        }, {
          "value": 1,
          "label": "Negatives",
          "color": "#ed2424",
          "field_id": "negatives"
        }],
        "prop": {
          "1": {
            "value": 1,
            "label": "#1",
            "active_color": "#f5ea14"
          },
          "2": {
            "value": 2,
            "label": "#2",
            "active_color": "#bbd531"
          },
          "3": {
            "value": 3,
            "label": "#3",
            "active_color": "#66b846"
          },
          "4": {
            "value": 4,
            "label": "#4",
            "active_color": "#0b7139"
          },
          "5": {
            "value": 5,
            "label": "#5",
            "active_color": "#06521f"
          },
          "-5": {
            "value": -5,
            "label": "#-5",
            "active_color": "#c42031"
          },
          "-4": {
            "value": -4,
            "label": "#-4",
            "active_color": "#ed2424"
          },
          "-3": {
            "value": -3,
            "label": "#-3",
            "active_color": "#f05f22"
          },
          "-2": {
            "value": -2,
            "label": "#-2",
            "active_color": "#f48020"
          },
          "-1": {
            "value": -1,
            "label": "#-1",
            "active_color": "#fab416"
          }
        },
        "average_rating_range": [-5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5],
        "average_rating_labels": [-5, -3, -1, 1, 3, 5],
        "percentage_labels": [0, 20, 40, 60, 80, 100],
        "number_of_ticks": 6
      },
      "2": {
        "name": "others",
        "min_score": 0,
        "max_score": 0,
        "distributions": [],
        "prop": {},
        "average_rating_range": [],
        "average_rating_labels": [],
        "percentage_labels": [],
        "number_of_ticks": 0
      },
      "3": {
        "name": "nps",
        "min_score": -100,
        "max_score": 100,
        "distributions": [{
          "value": 3,
          "label": "Promoters",
          "color": "#008000",
          "field_id": "promoters"
        }, {
          "value": 2,
          "label": "Passives",
          "color": "#ffa500",
          "field_id": "passives"
        }, {
          "value": 1,
          "label": "Detractors",
          "color": "#ff0000",
          "field_id": "detractors"
        }],
        "prop": {
          "0": {
            "value": 0,
            "label": "#0",
            "active_color": "#ed2424"
          },
          "1": {
            "value": 1,
            "label": "#1",
            "active_color": "#ed2424"
          },
          "2": {
            "value": 2,
            "label": "#2",
            "active_color": "#ed2424"
          },
          "3": {
            "value": 3,
            "label": "#3",
            "active_color": "#ed2424"
          },
          "4": {
            "value": 4,
            "label": "#4",
            "active_color": "#ed2424"
          },
          "5": {
            "value": 5,
            "label": "#5",
            "active_color": "#ed2424"
          },
          "6": {
            "value": 6,
            "label": "#6",
            "active_color": "#ed2424"
          },
          "7": {
            "value": 7,
            "label": "#7",
            "active_color": "#fab416"
          },
          "8": {
            "value": 8,
            "label": "#8",
            "active_color": "#fab416"
          },
          "9": {
            "value": 9,
            "label": "#9",
            "active_color": "#0b7139"
          },
          "10": {
            "value": 10,
            "label": "#10",
            "active_color": "#0b7139"
          }
        },
        "average_rating_range": [-100, -80, -60, -40, -20, 0, 20, 40, 60, 80, 100],
        "average_rating_labels": [-100, -60, -20, 20, 60, 100],
        "percentage_labels": [0, 20, 40, 60, 80, 100],
        "number_of_ticks": 6
      },
      "4": {
        "name": "1to5",
        "min_score": 0,
        "max_score": 5,
        "distributions": [{
          "value": 3,
          "label": "T2B",
          "color": "#10a754",
          "field_id": "top"
        }, {
          "value": 2,
          "label": "MB",
          "color": "#fab416",
          "field_id": "mid"
        }, {
          "value": 1,
          "label": "B2B",
          "color": "#ed2424",
          "field_id": "bottom"
        }],
        "prop": {
          "1": {
            "value": 1,
            "label": "#1",
            "active_color": "#c62828"
          },
          "2": {
            "value": 2,
            "label": "#2",
            "active_color": "#e53935"
          },
          "3": {
            "value": 3,
            "label": "#3",
            "active_color": "#f5ea14"
          },
          "4": {
            "value": 4,
            "label": "#4",
            "active_color": "#66b846"
          },
          "5": {
            "value": 5,
            "label": "#5",
            "active_color": "#1b5e20"
          }
        },
        "average_rating_range": [1, 2, 3, 4, 5],
        "average_rating_labels": [0, 1, 2, 3, 4, 5],
        "percentage_labels": [0, 20, 40, 60, 80, 100],
        "number_of_ticks": 6
      },
      "6": {
        "name": "1to10",
        "min_score": 0,
        "max_score": 10,
        "distributions": [{
          "value": 3,
          "label": "T3B",
          "color": "#10a754",
          "field_id": "top"
        }, {
          "value": 2,
          "label": "MB",
          "color": "#fab416",
          "field_id": "mid"
        }, {
          "value": 1,
          "label": "B3B",
          "color": "#ed2424",
          "field_id": "bottom"
        }],
        "prop": {
          "1": {
            "value": 1,
            "label": "#1",
            "active_color": "#b71c1c"
          },
          "2": {
            "value": 2,
            "label": "#2",
            "active_color": "#c62828"
          },
          "3": {
            "value": 3,
            "label": "#3",
            "active_color": "#d32f2f"
          },
          "4": {
            "value": 4,
            "label": "#4",
            "active_color": "#e53935"
          },
          "5": {
            "value": 5,
            "label": "#5",
            "active_color": "#f44336"
          },
          "6": {
            "value": 6,
            "label": "#6",
            "active_color": "#f5ea14"
          },
          "7": {
            "value": 7,
            "label": "#7",
            "active_color": "#bbd531"
          },
          "8": {
            "value": 8,
            "label": "#8",
            "active_color": "#66b846"
          },
          "9": {
            "value": 9,
            "label": "#9",
            "active_color": "#06521f"
          },
          "10": {
            "value": 10,
            "label": "#10",
            "active_color": "#1b5e20"
          }
        },
        "average_rating_range": [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
        "average_rating_labels": [0, 2, 4, 6, 8, 10],
        "percentage_labels": [0, 20, 40, 60, 80, 100],
        "number_of_ticks": 6
      },
      "7": {
        "name": "1to6",
        "min_score": 0,
        "max_score": 6,
        "distributions": [{
          "value": 3,
          "label": "T2B",
          "color": "#10a754",
          "field_id": "top"
        }, {
          "value": 2,
          "label": "MB",
          "color": "#fab416",
          "field_id": "mid"
        }, {
          "value": 1,
          "label": "B2B",
          "color": "#ed2424",
          "field_id": "bottom"
        }],
        "prop": {
          "1": {
            "value": 1,
            "label": "#1",
            "active_color": "#b71c1c"
          },
          "2": {
            "value": 2,
            "label": "#2",
            "active_color": "#d32f2f"
          },
          "3": {
            "value": 3,
            "label": "#3",
            "active_color": "#f44336"
          },
          "4": {
            "value": 4,
            "label": "#4",
            "active_color": "#f5ea14"
          },
          "5": {
            "value": 5,
            "label": "#5",
            "active_color": "#66b846"
          },
          "6": {
            "value": 6,
            "label": "#6",
            "active_color": "#1b5e20"
          }
        },
        "average_rating_range": [1, 2, 3, 4, 5, 6],
        "average_rating_labels": [0, 2, 4, 6],
        "percentage_labels": [0, 33, 67, 100],
        "number_of_ticks": 4
      },
      "8": {
        "name": "-3to+3",
        "min_score": -3,
        "max_score": 3,
        "distributions": [{
          "value": 2,
          "label": "Positives",
          "color": "#0b7139",
          "field_id": "positives"
        }, {
          "value": 1,
          "label": "Negatives",
          "color": "#ed2424",
          "field_id": "negatives"
        }],
        "prop": {
          "1": {
            "value": 1,
            "label": "#1",
            "active_color": "#f5ea14"
          },
          "2": {
            "value": 2,
            "label": "#2",
            "active_color": "#66b846"
          },
          "3": {
            "value": 3,
            "label": "#3",
            "active_color": "#1b5e20"
          },
          "-3": {
            "value": -3,
            "label": "#-3",
            "active_color": "#b71c1c"
          },
          "-2": {
            "value": -2,
            "label": "#-2",
            "active_color": "#d32f2f"
          },
          "-1": {
            "value": -1,
            "label": "#-1",
            "active_color": "#f44336"
          }
        },
        "average_rating_range": [-3, -2, -1, 0, 1, 2, 3],
        "average_rating_labels": [-3, -1, 1, 3],
        "percentage_labels": [0, 33, 67, 100],
        "number_of_ticks": 4
      },
      "9": {
        "name": "1to4",
        "min_score": 0,
        "max_score": 4,
        "distributions": [{
          "value": 3,
          "label": "TB",
          "color": "#10a754",
          "field_id": "top"
        }, {
          "value": 2,
          "label": "MB",
          "color": "#fab416",
          "field_id": "mid"

        }, {
          "value": 1,
          "label": "BB",
          "color": "#ed2424",
          "field_id": "bottom"
        }],
        "prop": {
          "1": {
            "value": 1,
            "label": "#1",
            "active_color": "#b71c1c"
          },
          "2": {
            "value": 2,
            "label": "#2",
            "active_color": "#e53935"
          },
          "3": {
            "value": 4,
            "label": "#4",
            "active_color": "#bbd531"
          },
          "4": {
            "value": 4,
            "label": "#4",
            "active_color": "#1b5e20"
          }
        },
        "average_rating_range": [1, 2, 3, 4],
        "average_rating_labels": [0, 1, 2, 3, 4],
        "percentage_labels": [0, 25, 50, 75, 100],
        "number_of_ticks": 5
      }
    };
    if (raterType in raters) {
      return JSON.parse(JSON.stringify(raters[raterType]));
    } else if (raterType) {
      return {};
    } else {
      return JSON.parse(JSON.stringify(raters));
    }
  }

  getDrillDownQuery(data: any, filters: any, tabName: string) {
    var params = this.getInitialQueryParameters();

    params.from = _.get(Helpers, 'datePicker.startDate');
    params.to = _.get(Helpers, 'datePicker.endDate');
    params.is_custom_date_range_selected = Helpers.isCustomDateRangeSelected;
    params.view_type = 'list';
    params.field_id = data.field_id;
    params.field_type = data.field_type;
    params.filters = filters;
    params.question_aggs = true;

    //For Response questions
    if (data.field_type && data.field_type == "response") {
      params.field_type = data.field_type;
      params.field_sub_type = data.field_sub_type;
      params.possible_values = data.field_possible_values;
    }

    if (Helpers.hierarchyStack && Helpers.hierarchyStack.length) {
      params.hierarchy_stack = Helpers.hierarchyStack;
    }
    params.actionable_filter = _.get(this.brandDetails, "action_management_configuration.actionables", {});
    params.action_type = tabName;
    var ageType =
      params.age_type = _.get(this.brandDetails, "action_management_configuration.ageing_config.type", 1);
    params.date_field = (_.get(Helpers, 'datePicker.dateFilterType', 1) == 1) ? "feedback_request_date" : "created_date";;
    if (params.action_type == "ageing" || params.action_type == "tat") {
      params.turnaround = _.get(this.brandDetails, "action_management_configuration.ageing_config.turnaround_time", '0');
      // send turn around time to calculate distribution
    }
    return params;
  }

  getTrendsRequestParams(parameter?: any) {
    var params: any = this.getInitialQueryParameters();

    params.from = _.get(Helpers, 'datePicker.startDate');
    params.to = _.get(Helpers, 'datePicker.endDate');
    params.brand_id = Helpers.brandDetails._id;
    if (Helpers.hierarchyStack && Helpers.hierarchyStack.length) {
      params.hierarchy_stack = Helpers.hierarchyStack;
    }
    params.caller = 1;
    params.use_es = true;
    params.trend_type = parameter.trendType
    params.main_rater_type = _.get(this.brandDetails, 'main_rater_type', 1);

    // If filter object is available then it will take data from that
    if (parameter.appliedfilters && parameter.appliedfilters.length) {
      // Set filters object if it is available. 
      params.filters = parameter.appliedfilters;
    }
    params.actionable_filter = _.get(Helpers.brandDetail, "action_management_configuration.actionables", {});
    params.action_type = parameter.action_type;
    params.age_type = _.get(Helpers.brandDetail, "action_management_configuration.ageing_config.type", 1);
    params.date_field = parameter.dateFilterField || "created_date";
    params.turnaround = _.get(Helpers.brandDetail, "action_management_configuration.ageing_config.turnaround_time", 0);
    return params;
  }

  processTrendsData(data: any) {
    let dataObject: any = {
      accountsOrProjectsNames: '',
      timestamp: [],
      within_tat: [],
      outside_tat: [],
      tat: [],
      age: [],
      resolved: [],
      unresolved: [],
      total_response: [],
      timeseries: [],
      percent: {
        within_tat: [],
        outside_tat: [],
        resolved: [],
        unresolved: [],
        total_response: [],
      }
    }
    _.each(data, (object: any) => {
      if (_.isEmpty(dataObject.accountsOrProjectsNames)) {
        dataObject.accountsOrProjectsNames = object.name
      }
      if (object.time) {
        let total = object.within_tat + object.outside_tat
        dataObject.timestamp.push(object.time);
        dataObject.within_tat.push(object.within_tat);
        dataObject.outside_tat.push(object.outside_tat);
        dataObject.total_response.push(total ? total : 0);
        dataObject.percent.within_tat.push(this.getPercentage(object.within_tat, total))
        dataObject.percent.outside_tat.push(this.getPercentage(object.outside_tat, total))
        dataObject.percent.total_response.push(this.getPercentage(total, total))
        if (object.tat >= 0) {
          dataObject.tat.push(object.tat.toFixed(2));
          dataObject.timeseries.push({ x: object.time, y: object.tat.toFixed(2) })
        } else if (object.age >= 0) {
          dataObject.age.push(object.age.toFixed(2));
          dataObject.timeseries.push({ x: object.time, y: object.age.toFixed(2) })
        } else {
          total = object.resolved + object.unresolved
          dataObject.resolved.push(object.resolved);
          dataObject.unresolved.push(object.unresolved);
          dataObject.total_response.push(total ? total : 0);
          dataObject.timeseries.push({ x: object.time, y: total.toFixed(2) })
          dataObject.percent.resolved.push(this.getPercentage(object.resolved, total))
          dataObject.percent.unresolved.push(this.getPercentage(object.unresolved, total))
          dataObject.percent.total_response.push(this.getPercentage(total, total))
        }
        dataObject.total_response.push(object.total_count);
      }
    })
    return dataObject;
  }

  getPercentage(count: number, total: number) {
    let percentage: any = '';
    if (count && total) {
      percentage = (((count / total) * 100)).toFixed(1);
      if (percentage >= 0) {
        return percentage;
      } else {
        return 0;
      }      
    } else {
      return 0;
    }
  }

  createDownloadJob(downloadQuery: any) {
    this.downloadService.createDashboardReportJob(downloadQuery).subscribe((reponse: any) => {
      if (reponse && reponse.code == 0 && reponse.data && reponse.data.ops && reponse.data.ops.length > 0) {
        this.downloadService.updateList(reponse.data.ops[0]);
        this.downloadService.showDownloadSideBar(true);
      } else if (reponse && reponse.data && reponse.data.code == 4021) {
        this._toastService.showPopup("WARN", "Please Wait", "Report generation is in process.", 3500);
      } else {
        this._toastService.showPopup("ERROR", "Error", "Error while generating request.", 3500);
      }
    })
  }

  prepareDataForExport(data: any, fieldsDetail: any) {
    let exportedData: any = [];
    if (fieldsDetail && !_.isEmpty(fieldsDetail)) {
      _.each(data, (object: any) => {
        let tempObject: any = {
          percent: {}
        };
        if (object.time) {
          _.each(fieldsDetail, (field: any) => {
            tempObject[field.dataKey] = this.formatData(object[field.dataKey], field);

            if (field.showPercentage) {
              tempObject.percent[field.dataKey] = this.getPercentage(object[field.dataKey], object[field.totalKey])
              tempObject[field.dataKey + '_with_percentage'] = tempObject[field.dataKey] + '(' + tempObject.percent[field.dataKey] + '%)'
            }
          })
          exportedData.push(tempObject);
        }
      })
    }
    return exportedData;
  }
  getPercent(total: any, value: any) {
    return Math.round(((value / total) * 100))

  }
  formatData(value: any, fieldObject: any) {
    switch (fieldObject.type) {
      case "date":
        return this.formatDateString(value, fieldObject);
      case "number":
        return this.formatNumber(value, fieldObject);
      case "string":
      default:
        return this.formatNumber(value, fieldObject);
    }
  }

  formatDateString(value: any, fieldObject: any) {
    if (_.hasIn(fieldObject, 'trendType') && !_.isEmpty(fieldObject.trendType)) {
      return moment(value).format(this.dateFormats[fieldObject.trendType]);
    } else if (_.hasIn(fieldObject, 'format')) {
      if (typeof fieldObject.format == "string" && !_.isEmpty(fieldObject.format)) {
        return moment(value).format(fieldObject.format);
      } else if (typeof fieldObject.format == "function") {
        return fieldObject.format(value);
      }
    }
    return value;
  }

  formatNumber(value: any, fieldObject: any) {
    if (_.hasIn(fieldObject, 'format')) {
      if (typeof fieldObject.format == "string" && !_.isEmpty(fieldObject.format)) {
        switch (fieldObject.format) {
          case 'round':
          default:
            return Math.round(value);
        }
      } else if (typeof fieldObject.format == "function") {
        return fieldObject.format(value);
      }
    }
    return value;

  }

  formatString(value: any, fieldObject: any) {
    if (_.hasIn(fieldObject, 'format')) {
      if (typeof fieldObject.format == "string" && !_.isEmpty(fieldObject.format)) {
        return value;
      } else if (typeof fieldObject.format == "function") {
        return fieldObject.format(value);
      }
    }
    return value
  }
  clone(data: any) {
    return JSON.parse(JSON.stringify(data))
  }
}
